/*
 * Cookie consent (owner, 2026-10-20): the choice is kept in this browser, in the "consent" cookie (a year). Until it's
 * made, the banner asks (components/layout/cookies); the switches (components/cookies) change it later. Analytics
 * (Google Analytics, Matomo, PostHog) load only when it's yes; turned off, their cookies are cleared and the page
 * reloads without them. A new tracker goes in load(), never straight into app.js.
 */
const TRACKERS = /^(_ga|_gid|_gat|_pk_|ph_|mp_)/;
const saved = document.cookie.match(/(?:^|; )consent=(yes|no)/)?.[1];
let loaded = false;

const load = () => {
    if (loaded) return;
    loaded = true;
    import('./tracking/google.js');
    import('./tracking/matomo.js');
    import('./tracking/posthog.js');
};

const clear = () => {
    const domains = ['', location.hostname, '.' + location.hostname.split('.').slice(-2).join('.')];
    for (const name of document.cookie.split('; ').map((cookie) => cookie.split('=')[0]).filter((name) => TRACKERS.test(name))) {
        domains.forEach((domain) => document.cookie = `${name}=; max-age=0; path=/${domain && '; domain=' + domain}`);
    }
    try {
        Object.keys(localStorage).filter((key) => TRACKERS.test(key)).forEach((key) => localStorage.removeItem(key));
    } catch {
        // Storage blocked: nothing kept there
    }
};

Alpine.store('consent', {
    analytics: saved === undefined ? null : saved === 'yes',   // null: not chosen yet

    set(analytics) {
        document.cookie = `consent=${analytics ? 'yes' : 'no'}; max-age=31536000; path=/; SameSite=Lax`;
        const withdrawn = loaded && !analytics;
        this.analytics = analytics;
        analytics ? load() : clear();
        if (withdrawn) location.reload();
    },
});

if (saved === 'yes') load();
